<template>
  <IconLucideCamera />
</template>
